export default {
  secret: process.env.REACT_APP_SECRET,
};
